import FormSelect from './FormSelect'
import { mapGetters } from 'vuex'
import _mapKeys from 'lodash/mapKeys'

import {
  getCipCodes
} from '@/api'
export default {
  extends: FormSelect,
  props: {
    config: {
      type: Object,
      default: () => ({
        multiple: false,
      }),
    },
  },
  data () {
    return {
      isOpen: false,
      isLoading: false,
      options: {},
      optionsLoaded: false,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    mergedConfig () {
      return {
        multiple: false,
        searchable: true,
        options: [],
        ...this.config,
      }
    },
    normalizedOptions () {
      const optionsArray = Object.values(this.options).map(el => el._id)
      const optionsWithHardCodedOptions = optionsArray.filter(Boolean).concat(this.mergedConfig.options || [])
      // ensuring options are unique and sorting the resulting array
      return [ ...new Set(optionsWithHardCodedOptions) ].sort()
    },
  },
  created () {
    return this.loadDataForSelectedOption()
  },
  watch: {
    isOpen: {
      async handler (val) {
        if (val && !this.optionsLoaded) {
          this.isLoading = true
          const data = await getCipCodes({ school: this.school, returnFields: [ '_id', 'cipCode', 'description' ] }) || {}
          this.options = _mapKeys(data, val => val.cipCode)
          this.optionsLoaded = true
          this.isLoading = false

        }
      },
    },
  },
  methods: {
    async loadDataForSelectedOption () {
      if (!this.value) return
      const data = await getCipCodes({ school: this.school, returnFields: [ '_id', 'cipCode', 'description' ], list: this.value }) || {}
      this.options = {
        ...this.options,
        ..._mapKeys(data, val => val.cipCode),
      }
    },
    normalizedOptionLabel (val) {
      if (!val) return val
      const obj = this.options[val]
      return obj ? `${obj.cipCode} - ${obj.description}` : val
    },
  },
}
